import * as React from 'react';

type TGlobalFormState = {
  isDirty: boolean;
  isSystemUser: boolean;
  setGlobalFormState: (isDirty: boolean, isSystemUser: boolean) => void;
};
export interface FieldState {
  field: string,
  fieldIsDirty: boolean,
}
interface IGlobalFormStateProvider {
  children: React.ReactNode;
}

const GlobalFormStateContext = React.createContext<TGlobalFormState>(undefined!);

export function GlobalFormStateProvider({ children }: IGlobalFormStateProvider) {
  const [isLocalDirty, setIsLocalDirty] = React.useState<boolean>(false);
  const [isSystemUser, setIsSystemUser] = React.useState<boolean>(false);
  const globalFormState = React.useMemo<TGlobalFormState>(() => ({
    isDirty: isLocalDirty,
    isSystemUser,
    setGlobalFormState: (newIsDirty: boolean, newIsSystemUser: boolean) => {
      setIsLocalDirty(newIsDirty);
      setIsSystemUser(newIsSystemUser);
    },
  }), [isLocalDirty, isSystemUser]);
  return (
    <GlobalFormStateContext.Provider value={globalFormState}>
      {children}
    </GlobalFormStateContext.Provider>
  );
}

export const useGlobalFormState = () => React.useContext(GlobalFormStateContext);
